import { ReactNode } from "react";
import "./TocAvailabilityNotice.css";
import { Alert } from "reactstrap";
import { faCloudShowersHeavy } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { SongsAvailability } from "./SongsAvailability";
import Header from "../Header";
import { LoadingMessage } from "../LoadingMessage";

interface Props {
  logout: () => void;
  tocAvailability: SongsAvailability;
}

export default function TocAvailabilityNotice(props: Props) {
  return generateToCUnavailableMessage(props);
}

function generateToCUnavailableMessage(props: Props): ReactNode {
  if (props.tocAvailability === SongsAvailability.Undecided) {
    return (
      <>
        <Header />
        <br />
        <LoadingMessage message="Bitte warte, während Songship das Inhaltsverzeichnis lädt." />
      </>
    );
  } else if (props.tocAvailability === SongsAvailability.ToCNotAvailable) {
    return (
      <>
        <Header />
        <br />
        <Alert color="danger" fade={false}>
          <h2 className={"light-header"}>
            <FontAwesomeIcon icon={faCloudShowersHeavy} /> Offline
          </h2>
          Das Inhaltsverzeichnis konnte weder aus dem lokalen Offline-Cache noch
          vom Internet geladen geladen werden. Bitte verbinde dich mit dem
          Internet, um die Daten herunterzuladen.
          <br />
          Falls du Probleme mit der Offline-Nutzung von Songship hast, melde
          dich bitte beim Support.
        </Alert>
      </>
    );
  } else {
    return <></>;
  }
}
